import React from 'react';
import { Employee } from '../app/types';
import EmployeeCard from '../components/EmployeeCard';

interface EmployeeListProps {
  employees: Employee[];
  onSelectEmployee: (employee: Employee) => void;
  email:string;
}

const EmployeeList: React.FC<EmployeeListProps> = ({ employees, onSelectEmployee, email }) => {
  if (employees.length === 0) {
    return (
      <div className="text-center py-16">
        <h3 className="text-xl font-medium text-on-surface dark:text-dark-on-surface">No se encontraron empleados</h3>
        <p className="text-on-surface-variant dark:text-dark-on-surface-variant mt-2">Intenta ajustar tu búsqueda.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
      {employees.map(employee => (
        <EmployeeCard key={employee.Id} employee={employee} onSelect={onSelectEmployee} email={email} />
      ))}
    </div>
  );
};

export default EmployeeList;